import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cnt: 0
}

export const counterSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        inc: (state) => {
            state.cnt += 5;
            state.cnt = state.cnt>=360? 0 : state.cnt;
        },
        reset: (state) => {
            state.cnt = 0;
        }
    }
})

export const { inc, reset } = counterSlice.actions;

export const selectCount = (state) => state.counter.cnt;

export default counterSlice.reducer;